import type { AdminReplacementPrice } from "@/types/admin-hardware-replacement-price";

/**
 * Fixture for `GET /admin/hardware/replacement-price` (mock mode).
 *
 * Deliberately SET, so mock mode exercises the populated render (amount +
 * audit trail) — the unset branch is covered by the tab's own tests rather
 * than by making every mock-mode session look mis-configured.
 *
 * Like every other mock mutation in this codebase, a mock-mode PUT returns a
 * synthetic echo and does NOT mutate this fixture — a refetch reads the
 * constant back. Mock mode exercises the UI flow, not backend persistence.
 */
export const MOCK_REPLACEMENT_PRICE: AdminReplacementPrice = {
  amountCents: 9900,
  currency: "usd",
  setAt: "2026-06-01T10:00:00Z",
  setByAdminId: "adm_owner_demo",
};
